import { call, put, takeLatest } from "redux-saga/effects";
import {
  validateLicensePlateError,
  validateLicensePlateStart,
  validateLicensePlateSucceded,
} from "./slice";

import { removeWhitespace } from "Formatting/index";
import { CART_RESOURCE_ROOT } from "Utils/apiUtils";
import { createRequest } from "Utils/requestUtils";
import { isAxiosError } from "axios";
import { LicensePlateValidationErrorType } from "./interfaces";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* validateLicensePlate({
  payload: { productId, licensePlateNumber },
}: ReturnType<typeof validateLicensePlateStart>) {
  try {
    const url = `${CART_RESOURCE_ROOT}/products/${productId}/validateLicensePlate`;
    yield call(createRequest, {
      method: "post",
      requestBody: licensePlateNumber
        ? { licensePlateNumber: removeWhitespace(licensePlateNumber) }
        : {},
      url,
      open: false,
    });
    yield put(validateLicensePlateSucceded(productId));
  } catch (e) {
    if (isAxiosError(e)) {
      yield put(
        validateLicensePlateError({
          productId,
          error: {
            errorType: e?.response?.data?.title,
            carFound: JSON.parse(e?.response?.data?.detail || "{}")?.carFound,
          },
        }),
      );
    } else {
      yield put(
        validateLicensePlateError({
          productId,
          error: {
            errorType: LicensePlateValidationErrorType.UNKNOWN_ERROR,
            carFound: undefined,
          },
        }),
      );
    }
  }
}

export function* validateLicensePlateSaga(): Generator {
  yield takeLatest(validateLicensePlateStart, validateLicensePlate);
}
